import React from "react";

export function FormID(props) {
    const maPlan = props.maPlans?.find(plan => plan.planId === props.maPlanId);
    const maPlanEffectiveDate = maPlan?.effectiveDateOptions?.find(option => option.effectiveDate === props.effectiveDate);
    const formId = maPlanEffectiveDate?.formId ?? "";

    return <div className={"ml-5 mt-5 print"}>
            <span className={"brand-color-lightgray"}>{formId}</span>
        </div>
}